
import { useI18n } from "vue-i18n";
import { defineComponent, ref, reactive, watch, computed } from "vue";
import { useRoute } from "vue-router";
import useClipboard from "vue-clipboard3";
import { DropdownMenu, DropdownItem, Toast, Loading, Icon, Popover } from "vant";
export default defineComponent({
  name: "example",
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [Popover.name]: Popover
  },
  setup() {
    const route = useRoute();
    const { t, locale } = useI18n();
    const { lang } = route.query;
    const showPopover = ref(false);
    const currentLang = ref();

    let data = reactive({
      dev: process.env.VUE_APP_BUILD_ENV,
      langs: [
        { text: "简体中文", value: "cn" },
        { text: "English", value: "en" }
      ]
    });

    currentLang.value = lang ?? "en";
    watch(
      currentLang,
      newLang => {
        locale.value = newLang;
      },
      {
        immediate: true
      }
    );

    const convertLangName = computed(() => {
      return (
        data.langs.find(x => {
          return x.value === locale.value;
        })?.text || ""
      );
    });
    const changeLang = item => {
      locale.value = item.value;
    };

    const { toClipboard } = useClipboard();
    const copy = async (text: string) => {
      try {
        await toClipboard(text);
      } catch (e) {
        console.error(e);
      }
    };

    return {
      data,
      showPopover,
      currentLang,
      convertLangName,
      changeLang,
      copy
    };
  }
});
